import axios from 'axios';
import { LinkPreviewProps } from '../home/PlaygroundTab/Post/LinkPreview';

export const detectLink = (text: string): string => {
  const urlRegex = /(https?:\/\/)?[\w-]+(\.[\w-]+)+\.?(:\d+)?(\/\S*)?/gi;
  const foundLinks = text.match(urlRegex) || [];

  if (foundLinks.length === 0) {
    return "";
  }

  const link = foundLinks[0];
  if (!link) {
    return "";
  }

  return link;
};

export const convertLinkToTag = (link: string): string => {
  return `<a href="${link}" target="_blank" rel="noopener noreferrer">${link}</a>`;
};

export const formatTimestamp = (timestamp: string): string => {
  const now = new Date();
  const postDate = new Date(timestamp);
  const diffInSeconds = Math.floor((now.getTime() - postDate.getTime()) / 1000);

  if (diffInSeconds < 60) {
    return `${diffInSeconds}s`;
  }

  const diffInMinutes = Math.floor(diffInSeconds / 60);
  if (diffInMinutes < 60) {
    return `${diffInMinutes}m`;
  }

  const diffInHours = Math.floor(diffInMinutes / 60);
  if (diffInHours < 24) {
    return `${diffInHours}h`;
  }

  const diffInDays = Math.floor(diffInHours / 24);
  if (diffInDays < 30) {
    return `${diffInDays}d`;
  }

  // If more than a month, return the date in MM/DD/YYYY format
  return postDate.toLocaleDateString('en-US', {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric'
  });
};

export const replaceLinkWithAnchor = (
  divRef: React.RefObject<HTMLDivElement>,
  text: string,
  htmlContent: string,
  onChange: (newText: string) => void
): void => {
  if (!divRef.current) return;

  // Handle empty text case
  if (text === '') {
    console.log('text is empty');
    onChange("");
    divRef.current.innerHTML = "";
    return;
  }

  console.log('htmlContent', htmlContent);
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const anchor = doc.querySelector('a');

  if (anchor) {
    const displayText = anchor.textContent || '';
    const href = anchor.getAttribute('href') || '';

    // Check if the link already exists
    const existingAnchor = divRef.current.querySelector(`a[href="${href}"]`);
    if (existingAnchor) {
      // If the link already exists, don't add it again
      return;
    }

    console.log('displayText', displayText);
    const textIndex = text.indexOf(displayText);
    console.log('textIndex', textIndex);

    if (textIndex !== -1) {
      const newText = text.replace(displayText, displayText);
      const innerHTML = divRef.current.innerHTML;
      const htmlTextIndex = innerHTML.indexOf(displayText);

      if (htmlTextIndex !== -1) {
        const beforeText = innerHTML.slice(0, htmlTextIndex);
        const afterText = innerHTML.slice(htmlTextIndex + displayText.length);
        divRef.current.innerHTML = beforeText + htmlContent + afterText;

        // Move caret to the end
        const selection = window.getSelection();
        const range = document.createRange();
        range.selectNodeContents(divRef.current);
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);

        onChange(newText);
      }
    }
  }
};

export const handleMentionDetection = (text: string) => {
  const matches = text.match(/@([^@]*)$/);
  const lastChar = text.slice(-1);
  const prevChar = text.slice(-2, -1);
  
  // Find all completed mentions (those that have been selected/confirmed)
  const completedMentionRegex = /@\w+/g;
  const completedMentions = text.match(completedMentionRegex) || [];
  
  // Find active mention (currently being typed)
  // If there's a space, only capture up to the space
  const activeMentionRegex = /@\w+(?=\s|$)/;
  const activeMention = text.match(activeMentionRegex);
  
  return {
    isNewMention: lastChar === '@' && prevChar !== '@',
    matches,
    activeMention,
    completedMentions
  };
};

export const styleMentions = (text: string, mentions: string[], activeMention: string | null) => {
  let styledContent = text;
  let offset = 0;

  // Handle completed mentions
  mentions.forEach(mention => {
    const mentionIndex = text.indexOf(mention, offset);
    if (mentionIndex !== -1) {
      // Only take the part before any space
      const mentionText = mention.split(' ')[0];
      const beforeMention = styledContent.slice(0, mentionIndex + offset);
      const afterMention = styledContent.slice(mentionIndex + offset + mentionText.length);
      const styledMention = `<span style="color: #0095F6">${mentionText}</span>`;
      styledContent = beforeMention + styledMention + afterMention;
      offset += styledMention.length - mentionText.length;
    }
  });

  // Handle active mention
  if (activeMention) {
    const mentionStart = text.lastIndexOf('@');
    if (mentionStart !== -1) {
      // Split at space and only take the first part
      const fullMentionText = text.slice(mentionStart).split(' ')[0];
      const beforeMention = styledContent.slice(0, mentionStart + offset);
      const afterMention = styledContent.slice(mentionStart + offset + fullMentionText.length);
      
      const styledMention = `<span style="color: #0095F6">${fullMentionText}</span>`;
      styledContent = beforeMention + styledMention + afterMention;
    }
  }

  return styledContent;
};